import { SiteStyles } from '@wix/cashier-common/dist/src/types/SiteStyles';
import React, { useEffect } from 'react';
import {
  DEFAULT_SITE_COLORS,
  DEFAULT_SITE_STYLES,
  DEFAULT_SITE_TEXT_PRESETS,
  DEFAULT_STYLE_PARAMS,
} from '../../../utils/defaultSiteStyles';
import { wixSdkAdapter } from '../../../utils/wixSdkAdapter';
import {
  getProcessedCss,
  getStaticCss,
} from 'tpa-style-webpack-plugin/runtime';
import { isRTLLocale } from '@wix/cashier-common/dist/src/utils/isRTLLocale';
import { IInternalCashierPaymentsProps } from '../../../cashier-payments';
import { captureError, logDebugMessage } from '../../../utils/errorReporter';
import * as s from '../styles.scss';

export const withStyles = (
  Widget: React.ComponentClass<IInternalCashierPaymentsProps>
) => {
  return (props: IInternalCashierPaymentsProps) => {
    let staticCss: string = '';
    let dynamicCss: string = '';

    // tslint:disable-next-line:react-hooks-nesting
    useEffect(() => {
      if (
        props.shouldApplySiteStyles &&
        !props.siteStyles &&
        wixSdkAdapter.getSiteStyles() &&
        !wixSdkAdapter.getSiteStyles().styleParams
      ) {
        logDebugMessage(`"styleParams" is missing in "sdkSiteStyles"`);
      }
    }, []);

    try {
      const sdkSiteStyles = wixSdkAdapter.getSiteStyles();
      const siteStyles: SiteStyles = props.shouldApplySiteStyles
        ? {
            siteColors:
              props.siteStyles?.siteColors ||
              sdkSiteStyles?.siteColors ||
              DEFAULT_SITE_COLORS,
            siteTextPresets:
              props.siteStyles?.siteTextPresets ||
              sdkSiteStyles?.siteTextPresets ||
              DEFAULT_SITE_TEXT_PRESETS,
            styleParams:
              props.siteStyles?.styleParams ||
              sdkSiteStyles?.styleParams ||
              DEFAULT_STYLE_PARAMS,
          }
        : DEFAULT_SITE_STYLES;

      const cssOptions = {
        prefixSelector: '',
        isRTL: isRTLLocale(props.configuration.locale || props.locale),
        strictMode: false,
      };

      staticCss = getStaticCss(cssOptions);
      dynamicCss = getProcessedCss(siteStyles, cssOptions);
    } catch (e) {
      captureError(e);
      return <Widget {...props} />;
    }

    return (
      <div className={s.rootNode} style={{ maxWidth: props.maxWidth }}>
        <style dangerouslySetInnerHTML={{ __html: dynamicCss }} />
        <style dangerouslySetInnerHTML={{ __html: staticCss }} />
        <Widget {...props} />
      </div>
    );
  };
};
